import gql from 'graphql-tag';

export const QUERY_USER = gql`query QueryUser {
      viewer {
        acfUserData {
          wishlist
          acct
        }
      }
    }
`;

export default QUERY_USER;